import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress  } from 'antd';
import { init,isStartIdo,getIdoList,transferBnb,allIdoETH } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import {getNftIndex} from "../../api";
import CountUp from "react-countup";
import { useTranslation } from 'react-i18next'
import {getTuanInfo, register,login} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';
import { max } from 'moment';
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}

const Nft = (props) => {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const [num,setNum] = useState(0)


    const [zhiNum,setZhiNum] = useState(0)
const [small,setSmall] = useState(0)
    const [taskNum1,setTaskNum1] = useState(0)
    const [taskNum2,setTaskNum2] = useState(0)
    const [taskNum3,setTaskNum3] = useState(0)

    // const [nftDayBonus1,setNftDayBonus1] = useState(0)
    // const [nftDayBonus2,setNftDayBonus2] = useState(0)
    // const [nftDayBonus3,setNftDayBonus3] = useState(0)
    // const [nftAllBonus1,setNftAllBonus1] = useState(0)
    // const [nftAllBonus2,setNftAllBonus2] = useState(0)
    // const [nftAllBonus3,setNftAllBonus3] = useState(0)
    // const [nftBonus1,setNftBonus1] = useState(0)
    // const [nftBonus2,setNftBonus2] = useState(0)
    // const [nftBonus3,setNftBonus3] = useState(0)
    // const [tokenId1,setTokenId1] = useState("")
    // const [tokenId2,setTokenId2] = useState("")
    // const [tokenId3,setTokenId3] = useState("")
   const [nft0,setNft0] = useState([])
    const [nft1,setNft1] = useState([])
     const [nft2,setNft2] = useState([])
   
    const [nftIndex,setNftIndex] = useState(3)
    
    
  
    const ref = useRef()

    const _getPledgeCcerIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getNftIndex().then(res=>{
            if(res.code === 0 ){
                setZhiNum(res.data.zhiNum)
                setTaskNum1(res.data.task_num1)
                setTaskNum2(res.data.task_num2)
                setTaskNum3(res.data.task_num3)
                setSmall(res.data.small_ido)
                 if(res.data.nft0!==null){
                        setNft0(res.data.nft0)
                    }

                      if(res.data.nft1!==null){
                        setNft1(res.data.nft1)
                    }

                          if(res.data.nft2!==null){
                        setNft2(res.data.nft2)
                    }

                // setNftDayBonus1(res.data.nft_day_bonus1)
                // setNftDayBonus2(res.data.nft_day_bonus2)
                // setNftDayBonus3(res.data.nft_day_bonus3)

                // setNftAllBonus1(res.data.nft_all_bonus1)
                // setNftAllBonus2(res.data.nft_all_bonus2)
                // setNftAllBonus3(res.data.nft_all_bonus3)

                // setNftBonus1(res.data.nft_bonus1)
                // setNftBonus2(res.data.nft_bonus2)
                // setNftBonus3(res.data.nft_bonus3)

                // setTokenId1(res.data.tokenid1)
                // setTokenId2(res.data.tokenid2)
                // setTokenId3(res.data.tokenid3)
          
                

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }

    const goLiushui = (url)=>{
        //     message.error(t('g.暂未开放'))
        //    return
            if(props.address.length<=0 ){
                message.error(t('head.请先连接钱包'))
                return false
            }
            navigate(url,{
                state:{
                    address:props.address
                }
            })
        }



    useEffect(() => {
        window.scrollTo(0, 0)
       
        _getPledgeCcerIndex()
           
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    

    return (
        <>
            <Head/>
            

            
            
            <div style={{"backgroundColor":"#EBF0F6"}} className=' pb-20 w-full lg:w-1/3 min-h-screen  pt-16 text-white flex flex-col'>
            {/*  */}
                <div className='w-full px-4  h-[550px]  taskBg1'>
                   

                    
                        
                        <div className="w-full mt-[40px] mb-[17px]  flex felx-row justify-start items-center">
                            
                            <span className=' text-2xl text-black fontB'>{t('nft.为激励市场活跃而设计')}</span>
                        </div>
                        <div className="w-full mt-[30px] mb-[15px]  flex felx-row justify-start items-center">
                            
                            <p className=' text-sm text-[#999999] fontM'>{t('nft.通过的各阶段目标目标的达成，制定了合理的激励计划，可通过完成任务来获取代币奖励及等级的提示')}</p>
                        </div>
                        <div className="w-full  mb-[17px]  flex felx-row justify-start items-center text-sm fontB">
                            
                            <div onClick={()=>goLiushui("/mint")} className='w-[150px] h-[50px] mr-4 flex flex-row border border-gray-300 justify-center items-center  rounded-full text-gray-500'>Mint</div>
                           
                        </div>
                       
                    
                </div>

            {/*  */}
            <div className='w-full mt-10 mb-3 px-4 '>
                    <h2 className=' text-gray-800 text-2xl'><span className=' text-text-act'>{t('nft.任务')}</span>{t('nft.必要达成条件')}</h2>
            </div>

            <div className='bg-[#EBF0F6] mx-4 h-16 rounded-xl border border-gray-300 px-5  flex flex-row justify-between items-center text-gray-500'>
                <div>{t('nft.有效邀请数')}</div>
                <div className='w-1/3 h-16 flex flex-col items-center justify-center border-x border-gray-300'>
                    <span className=' text-base text-[#0042bd]'><CountUp start={0} end={zhiNum} duration="1" decimals={0} /></span>
                    <div className='w-10 border-t border-dashed border-gray-300'></div>
                    <div className=' text-base text-gray-400'>9</div>
                </div>
                    {
                    zhiNum>=9?(
                        <div className=' rounded-full bg-green-300 px-3 py-1 text-white text-xs'>
                            {t('nft.已完成')}
                        </div>
                    ):(
                        <div className=' rounded-full bg-orange-300 px-3 py-1 text-white text-xs'>
                            {t('nft.待完成')}
                        </div>
                    )
                }
                

            </div>

            {/*  */}
            <div className='w-full mt-10 mb-3 px-4 '>
                    <h2 className=' text-gray-800 text-2xl'>{t('nft.开放的任务列表')}</h2>
            </div>

             <div className='mx-4 h-16  border border-gray-300 border-b-0 bg-[#E8EDF3] rounded-t-xl  flex flex-row justify-between items-center text-gray-500'>
                <div className='w-1/4 text-center'>{t('nft.铸造任务')}</div>
                <div className='w-2/4 h-16 flex flex-col items-center justify-center border-x border-gray-300'>
                    {t('nft.小社区达成指标')}
                </div>
            
                <div className='w-1/4   text-xs text-center flex flex-row justify-center'>
                    {t('nft.完成度')}
                </div>

            </div>
            <div className='bg-[#EBF0F6] mx-4 h-24  border border-gray-300   flex flex-row justify-between items-center text-gray-500'>
                <div className='w-1/4 text-center flex flex-row justify-center items-center'>
                {t('share.铜矿主')}
                {/* <img alt='rr' className=' mr-1' src={require('../../assets/img/f.png')} style={{"width":"30px"}}></img> */}
                </div>
                <div className='w-2/4 h-24 flex flex-col items-center justify-center border-x border-gray-300'>
                    <span className=' text-base text-[#0042bd]'>$<CountUp start={0} end={small} duration="1" decimals={2} /></span>
                    <div className='w-10 my-1 border-t border-dashed border-gray-300'></div>
                    <div className=' text-base text-gray-400'>$10000.00</div>
                </div>
                <div className='w-1/4  text-white text-xs text-center flex flex-row justify-center'>
                <Progress type="circle" percent={taskNum1} />
                    {/* <span className=' rounded-full bg-orange-300 px-3 py-1 text-white text-xs text-center'>0.00%</span> */}
                </div>

            </div>
            <div className='bg-[#EBF0F6] mx-4 h-24  border border-gray-300 border-t-0   flex flex-row justify-between items-center text-gray-500'>
                <div className='w-1/4 text-center'>{t('share.银矿主')}</div>
                <div className='w-2/4 h-24 flex flex-col items-center justify-center border-x border-gray-300'>
                    <span className=' text-base text-[#0042bd]'>$<CountUp start={0} end={small} duration="1" decimals={2} /></span>
                    <div className='w-10 my-1 border-t border-dashed border-gray-300'></div>
                    <div className=' text-base text-gray-400'>$30000.00</div>
                </div>
                <div className='w-1/4  text-white text-xs text-center flex flex-row justify-center'>
                <Progress type="circle" percent={taskNum2} />
                    {/* <span className=' rounded-full bg-orange-300 px-3 py-1 text-white text-xs text-center'>0.00%</span> */}
                </div>

            </div>
            <div className='bg-[#EBF0F6] mx-4 h-24  border border-gray-300  border-t-0 rounded-b-xl   flex flex-row justify-between items-center text-gray-500'>
                <div className='w-1/4 text-center'>{t('share.金矿主')}</div>
                <div className='w-2/4 h-24 flex flex-col items-center justify-center border-x border-gray-300'>
                    <span className=' text-base text-[#0042bd]'>$<CountUp start={0} end={small} duration="1" decimals={2} /></span>
                    <div className='w-10 my-1 border-t border-dashed border-gray-300'></div>
                    <div className=' text-base text-gray-400'>$50000.00</div>
                </div>
                <div className='w-1/4  text-white text-xs text-center flex flex-row justify-center'>
                <Progress type="circle" percent={taskNum3} />
                    {/* <span className=' rounded-full bg-orange-300 px-3 py-1 text-white text-xs text-center'>0.00%</span> */}
                </div>

            </div>

            {/*  */}


                {/*  */}
               

                

                {/*  */}
                  


                
                {/*  */}

                

            

                

               

                
            </div>
            

                {/* <div className=' w-full h-28'></div> */}
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Nft);
